module.exports = __webpack_public_path__ + "img/ico-pinterest-2x.ea5d86c8.png";